import {CategoryTable} from '@widgets/category';

export const CategoriesPage = () => {
  return <CategoryTable />;
};
